<template>
  <div class="btn-wrapper"
       :style="{'grid-column-start': dataCol,'grid-row-start': dataRow}">
    <button class="flex-center"
            @click="$emit('click', {col: dataCol, row: dataRow})">
      <i class="mdi mdi-plus"></i>
    </button>
    {{$t('message.campaigns.message.newScreen')}}
  </div>
</template>

<script>
    export default {
        props: {
            dataCol: {
                type: Number,
            },
            dataRow: {
                type: Number,
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.btn-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;

  button {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    border: 2px solid $grey-1;
    font-size: 32px;
    margin-bottom: 4px;
  }
}
</style>
